import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Button, Icon, notification } from 'antd';
import PropTypes, { oneOfType } from 'prop-types';
import classNames from 'classnames/bind';
import Enums from 'utils/EnumsManager';
import { criterialToApiWithRightSider, criterialToApi, formatSiderOptions } from '../utils/criterialUtils';
import { triggerToApi } from '../utils/triggerUtils';
import { addWorkFlow, updateWorkFlow } from '../flow/action';
import styles from '../index.less';

const { PhantomId, FieldTypes } = Enums;
const {
 Lookup, PickList
} = FieldTypes;
const cx = classNames.bind(styles);
const defaultProps = {
  workFlowRule: {},
  workFlowCriteria: {},
  WorkFlowTrigger: {},
  triggerMeta: {},
};
const propTypes = {
  workFlowRule: PropTypes.object,
  workFlowCriteria: PropTypes.object,
  WorkFlowTrigger: PropTypes.object,
  triggerMeta: PropTypes.object,
  workFlowId: oneOfType([
    PropTypes.string,
    PropTypes.number
  ]).isRequired,
  addWorkFlow: PropTypes.func.isRequired,
  updateWorkFlow: PropTypes.func.isRequired,
};

const errorMsg = message => {
  notification.error({
    message,
    duration: 3
  });
};

class ActionGroup extends React.Component {
  validateRules = () => {
    const { validateRuleForm, intl } = this.props;
    const { formatMessage } = intl;
    const formErrors = validateRuleForm();
    if (!_.isEmpty(formErrors)) {
      errorMsg(formatMessage({ id: 'global.errors.oneFieldRequired' }));
      return false;
    }
    return true;
  }

  validateCriteria = () => {
    const { workFlowCriteria, intl } = this.props;
    const { formatMessage } = intl;
    const { criteria, criteriaLogic } = workFlowCriteria;
    if (!_.isEmpty(criteria) && _.isEmpty(criteriaLogic)) {
      errorMsg(formatMessage({ id: 'global.errors.oneFieldRequired' }));
      return false;
    }
    return true;
  }

  validateTrigger = () => {
    const { WorkFlowTrigger, intl } = this.props;
    const { triggerSessions } = WorkFlowTrigger;
    const { formatMessage } = intl;
    if (_.isEmpty(triggerSessions)) {
      errorMsg(formatMessage({ id: 'page.WorkFlow.errors.triggerNeeded' }));
      return false;
    }
    return true;
  }

  validateAllValue = () => {
    const rulesValidation = this.validateRules();
    const criteriaValidation = this.validateCriteria();
    const triggerValidation = this.validateTrigger();
    if (!rulesValidation || !criteriaValidation || !triggerValidation) return false;
    return true;
  }

  handleCancle = () => {
    const { history } = this.props;
    history.push('/setup/settings/workflow');
  }

  handleSave = () => {
    const allValidation = this.validateAllValue();
    if (!allValidation) return false;
    const {
      workFlowRule,
      workFlowCriteria,
      WorkFlowTrigger,
      triggerMeta,
      workFlowId,
      addWorkFlow,
      updateWorkFlow,
      history,
      metaFields,
      criteria
    } = this.props;

    // the matched value that will be sent as the payload to the submit request

    // only apply this rule when criteria type is picklist
    let matchApiCriteria = workFlowCriteria.criteria.map(c => {
      if(c.type === PickList) {
        //find the current selected field
        const selectedField = metaFields.find(f => f.id === c.fieldId)
            
        // map the selected field option list
        const rightSiderList = _.isArray(selectedField.picklists) ? formatSiderOptions(selectedField.picklists, c.type) : []
        return criterialToApiWithRightSider(c, rightSiderList)
      } 
      return criterialToApi(c)
    });

    const { ruleName, ruleDescription, ruleWhen } = workFlowRule;
    const matchApiTrigger = WorkFlowTrigger.triggerSessions.map(t => triggerToApi(t, WorkFlowTrigger.actionFilters, triggerMeta));
    const data = {
      op_code: ruleWhen,
      name: ruleName,
      description: ruleDescription,
      is_active: true,
      condition: {
        sub_conditions: matchApiCriteria,
        logic: workFlowCriteria.criteriaLogic,
      },
      actions: matchApiTrigger,
    };
    if (workFlowId === PhantomId) {
      addWorkFlow(data, () => history.push('/setup/settings/workflow'));
    } else {
      updateWorkFlow(data, workFlowId, () => history.push('/setup/settings/workflow'));
    }
  }

  render() {
    return (
      <div className={cx('actionGroup-container')}>
        <Button
          size="small"
          onClick={this.handleSave}
        >
          <Icon type="save" />
          <FormattedMessage id="global.ui.button.save" />
        </Button>
        <Button
          size="small"
          className={classNames(cx('actionGroup-cancel-btn'), 'ml-sm', 'mb-xlg')}
          onClick={this.handleCancle}
        >
          <Icon type="close" />
          <FormattedMessage id="global.ui.button.cancel" />
        </Button>
      </div>
    );
  }
}

ActionGroup.defaultProps = defaultProps;
ActionGroup.propTypes = propTypes;

const mapStateToProps = ({ global, setup }) => {
  const { workFlowRule, workFlowCriteria, WorkFlowTrigger, metaData } = setup.workFlow;
  return {
    lang: global.language,
    workFlowRule,
    workFlowCriteria,
    WorkFlowTrigger,
    triggerMeta: metaData.triggerMeta
  };
};
const mapDispatchToProps = {
  addWorkFlow,
  updateWorkFlow
};

const Enhancer = compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps),
  injectIntl
);

export default Enhancer(ActionGroup);



// WEBPACK FOOTER //
// ./src/views/Setup/WorkFlow/components/ActionGroup.jsx